import { render, staticRenderFns } from "./index.vue?vue&type=template&id=539fb212&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=539fb212&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539fb212",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('539fb212')) {
      api.createRecord('539fb212', component.options)
    } else {
      api.reload('539fb212', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=539fb212&scoped=true", function () {
      api.rerender('539fb212', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/placesCompare/index.vue"
export default component.exports